import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import NavBar from './components/NavBar';

import NotFound from './pages/NotFound';
import ContactFormSubmissions from './pages/Admin/ContactFormSubmissions';

import MemberInfoPage from './pages/Team/MemberInfoPage';
import LandingPage from './pages/LandingPage';
import WhyJaiPage from './pages/NavBarPages/WhyJaiPage';
import AboutPage from './pages/NavBarPages/AboutPage';
import ContactsPage from './pages/Team/ContactsPage';

import AccountEditPage from './pages/Platform/AccountEditPage';
import AccountReviewPage from './pages/Platform/AccountReviewPage';
import AccountLoginPage from './pages/Platform/AccountLoginPage';
import AccountCreatePage from './pages/Platform/AccountCreatePage';
import ForgotPasswordPage from './pages/Platform/ForgotPasswordPage';
import ApplicationTrackingPage from './pages/Platform/ApplicationTrackingPage';

import VisaTravelOverviewPage from './pages/VisaPages/Travel/VisaTravelOverviewPage';
import ApplyOnboardingPage from './pages/Platform/ApplyOnboardingPage';
import BurabaiArticle from './pages/Sights/BurabaiArticle';
import MapPage from './pages/Platform/MapPage';

import VisaWorkOverviewPage from './pages/VisaPages/Labour/VisaWorkOverviewPage';
import OpenCompanyVisaPage from './pages/VisaPages/Investment/OpenCompanyVisaPage';
import AifcInfoPage from './pages/VisaPages/Investment/AifcInfoPage';
import VisaStudyOverviewPage from './pages/VisaPages/Study/VisaStudyOverviewPage';

import PrivacyPolicyPage from './pages/Legal/PrivacyPolicyPage';
import TermsOfServicePage from './pages/Legal/TermsOfServicePage';
import OffCanvasMenuBar from './components/OffCanvasMenuBar';

import AktauCityPage from './pages/Cities/AktauCityPage';
import AlmatyCityPage from './pages/Cities/AlmatyCityPage';
import AstanaCityPage from './pages/Cities/AstanaCityPage';
import SemeyCityPage from './pages/Cities/SemeyCityPage';
import KaragandaCityPage from './pages/Cities/KaragandaCityPage';
import ShymkentCityPage from './pages/Cities/ShymkentCityPage';
import TurkistanCityPage from './pages/Cities/TurkistanCityPage';

import AlakolSightPage from './pages/Sights/AlakolSightPage';
import AltynEmelSightPage from './pages/Sights/AltynEmelSightPage';
import BalkhashSightPage from './pages/Sights/BalkhashSightPage';
import BurabaiSightPage from './pages/Sights/BurabaiSightPage';
import CharynSightPage from './pages/Sights/CharynSightPage';
import KolsaiSightPage from './pages/Sights/KolsaiSightPage';
import MangistauSightPage from './pages/Sights/MangistauSightPage';
import MarkakolSightPage from './pages/Sights/MarkakolSightPage';
import QayindySightPage from './pages/Sights/QayindySightPage';
import UlytauSightPage from './pages/Sights/UlytauSightPage';

import PostJobPage from './pages/Jobs/PostJobPage';
import JobListingsPage from './pages/Jobs/JobListingsPage';
import JobDetailsPage from './pages/Jobs/JobDetailsPage';
import SpecialZonesInfoPage from './pages/VisaPages/Investment/SpecialZonesInfoPage';

import MekgrajPartnerPage from './pages/Partners/MekgrajPartnerPage';
import PassportForm from './pages/Platform/PassportForm';
import PartnerPage from './pages/Partners/PartnerPage';
import A5VisaPage from './pages/VisaPages/Investment/A5VisaPage';
import AdminPanelPage from './pages/Admin/AdminPanelPage';


/**
 * The initial point of Jai Web App
 * @returns 
 */
function App()
{
	return (
		<BrowserRouter>

      {/* Traditional horizontal navigation bar */}
      <NavBar />
      
      {/* Vertical navigation menu sliding from the right side on the mobile devices  */}
      <OffCanvasMenuBar />
			
      <Routes>
        {/* Catch-all fallback route */}
				<Route path="*" element={<NotFound />} />
        <Route path="/form-submissions" element={<ContactFormSubmissions />} />
        <Route path="/platform/form-submissions" element={<ContactFormSubmissions />} />
        <Route path="/platform/admin-panel" element={<AdminPanelPage />} />
        <Route path="/map" element={<MapPage />} />

        {/* Main landing page */}
				<Route path="/" element={<LandingPage/>} />
        <Route path="/why-jai" element={<WhyJaiPage/>} />
        <Route path="/about" element={<AboutPage/>} />
        <Route path="/team" element={<ContactsPage/>} />
        <Route path="/team/:id" element={<MemberInfoPage />} />

        {/* Investing Article Pages */}
        <Route path="/investment/visa-a5" element={<A5VisaPage/>} />
        <Route path="/investment/open-company" element={<OpenCompanyVisaPage/>} />
        <Route path="/investment/special-zones" element={<SpecialZonesInfoPage/>} />
        <Route path="/investment/aifc" element={<AifcInfoPage/>} />

        {/* Services Dropdown Pages */}
        <Route path="/travel-overview" element={<VisaTravelOverviewPage/>} />
        <Route path="/travel/burabai" element={<BurabaiArticle />} />
        <Route path="/work-overview" element={<VisaWorkOverviewPage/>} />
        <Route path="/study-overview" element={<VisaStudyOverviewPage/>} />

        {/* Account Manipulation Pages */}
        <Route path="/apply-visa" element={<ApplyOnboardingPage/>} />
        <Route path="/passport-form" element={<PassportForm/>} />
        <Route path="/create-account" element={<AccountCreatePage/>} />
        <Route path="/sign-in" element={<AccountLoginPage/>} />
        <Route path="/my-account" element={<AccountReviewPage/>} />
        <Route path="/forgot-password" element={<ForgotPasswordPage/>} />
        <Route path="/account-edit" element={<AccountEditPage/>} />
        <Route path="/platform/applications/:id" element={<ApplicationTrackingPage />} />

        {/* Footer Pages */}
        <Route path="/terms-of-service" element={<TermsOfServicePage/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage/>} />
        <Route path="/partners/mekgraj" element={<MekgrajPartnerPage/>} /> {/* Do NOT TOUCH THIS */}
        <Route path="/partner/:partnerId" element={<PartnerPage/>} /> {/* Multiselector */}

        {/* Jobs Pages */}

        <Route path="/jobs/post-new" element={<PostJobPage />} />
        <Route path="/jobs/all" element={<JobListingsPage />} />
        <Route path="/jobs/:id" element={<JobDetailsPage />} />

        {/* Cities */}
        <Route path="/cities/aktau" element={<AktauCityPage />} />
        <Route path="/cities/almaty" element={<AlmatyCityPage />} />
        <Route path="/cities/astana" element={<AstanaCityPage />} />
        <Route path="/cities/semipalatinsk" element={<SemeyCityPage />} />
        <Route path="/cities/karaganda" element={<KaragandaCityPage />} />
        <Route path="/cities/shymkent" element={<ShymkentCityPage />} />
        <Route path="/cities/turkistan" element={<TurkistanCityPage />} />
        
        {/* Sights */}
        <Route path="/sights/alakol" element={<AlakolSightPage />} />
        <Route path="/sights/altyn-emel" element={<AltynEmelSightPage />} />
        <Route path="/sights/balkhash" element={<BalkhashSightPage />} />
        <Route path="/sights/burabai" element={<BurabaiSightPage />} />
        <Route path="/sights/charyn" element={<CharynSightPage />} />
        <Route path="/sights/kolsai" element={<KolsaiSightPage />} />
        <Route path="/sights/mangistau" element={<MangistauSightPage />} />
        <Route path="/sights/markakol" element={<MarkakolSightPage />} />
        <Route path="/sights/qayindy" element={<QayindySightPage />} />
        <Route path="/sights/ulytau" element={<UlytauSightPage />} />

			</Routes>
		</BrowserRouter>
	);
}

export default App;
